import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { deleteWorkflowApi } from "../../../api/apiLists/workflow";
import {
  deleteWorkflowFailure,
  deleteWorkflowRequest,
  deleteWorkflowStart,
  deleteWorkflowSuccess,
  fetchWorkflowListRequest
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleDeleteWorkflow(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(deleteWorkflowStart());

    const req = action.payload || { operation: "DELETE_WORKFLOW", payload: {} };
    const res = yield callWorkflowApi(deleteWorkflowApi, req);

    if (res?.status) {
      yield put(deleteWorkflowSuccess(res?.data || null));
      yield put(showAlert({
        message: res?.data?.message || "Workflow deleted successfully.",
        type: "success"
      }));
      yield put(fetchWorkflowListRequest({ operation: "LIST_WORKFLOWS", payload: {} }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to delete workflow";
    yield put(deleteWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to delete workflow";
    yield put(deleteWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowDeleteSaga() {
  yield takeLatest(deleteWorkflowRequest.type, handleDeleteWorkflow);
}
